import { render, staticRenderFns } from "./CustomerHostReceivedInvoices.vue?vue&type=template&id=0b5b3b11&scoped=true&"
import script from "./CustomerHostReceivedInvoices.vue?vue&type=script&lang=js&"
export * from "./CustomerHostReceivedInvoices.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHostReceivedInvoices.vue?vue&type=style&index=0&id=0b5b3b11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b3b11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
